import type { StorageUsage } from '@trove/contracts';
import { formatSize } from './formatSize';

/** Show a sidebar notice once usage reaches this share of the account limit. */
export const STORAGE_WARN_RATIO = 0.8;
export const STORAGE_CRITICAL_RATIO = 0.95;

export type StoragePressure = 'ok' | 'warn' | 'critical' | 'full';

export function storageRatio(usage: Pick<StorageUsage, 'usedBytes' | 'limitBytes'>) {
  if (!usage.limitBytes || usage.limitBytes <= 0) return 0;
  return Math.max(0, usage.usedBytes / usage.limitBytes);
}

export function storagePressure(
  usage: Pick<StorageUsage, 'usedBytes' | 'limitBytes'>,
): StoragePressure {
  const ratio = storageRatio(usage);
  if (ratio >= 1) return 'full';
  if (ratio >= STORAGE_CRITICAL_RATIO) return 'critical';
  if (ratio >= STORAGE_WARN_RATIO) return 'warn';
  return 'ok';
}

export function storageUsageLabel(usage: Pick<StorageUsage, 'usedBytes' | 'limitBytes'>) {
  return `${formatSize(usage.usedBytes)} / ${formatSize(usage.limitBytes)}`;
}

export function storagePercentLabel(usage: Pick<StorageUsage, 'usedBytes' | 'limitBytes'>) {
  return `${Math.min(100, Math.round(storageRatio(usage) * 100))}%`;
}
